<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M2,6C0.9,6,0,6.9,0,8C0,9.1,0.9,10,2,10C3.1,10,4,9.1,4,8C4,6.9,3.1,6,2,6C2,6,2,6,2,6ZM2,11C0.9,11,0,11.9,0,13C0,14.1,0.9,15,2,15C3.1,15,4,14.1,4,13C4,11.9,3.1,11,2,11C2,11,2,11,2,11ZM14,4C15.1,4,16,3.1,16,2C16,0.9,15.1,0,14,0C12.9,0,12,0.9,12,2C12,3.1,12.9,4,14,4C14,4,14,4,14,4ZM2,1C0.9,1,0,1.9,0,3C0,4.1,0.9,5,2,5C3.1,5,4,4.1,4,3C4,1.9,3.1,1,2,1C2,1,2,1,2,1ZM9,9C7.9,9,7,9.9,7,11C7,12.1,7.9,13,9,13C10.1,13,11,12.1,11,11C11,9.9,10.1,9,9,9C9,9,9,9,9,9ZM9,3C7.9,3,7,3.9,7,5C7,6.1,7.9,7,9,7C10.1,7,11,6.1,11,5C11,3.9,10.1,3,9,3C9,3,9,3,9,3ZM14,6C12.9,6,12,6.9,12,8C12,9.1,12.9,10,14,10C15.1,10,16,9.1,16,8C16,6.9,15.1,6,14,6C14,6,14,6,14,6ZM14,12C12.9,12,12,12.9,12,14C12,15.1,12.9,16,14,16C15.1,16,16,15.1,16,14C16,12.9,15.1,12,14,12C14,12,14,12,14,12Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'LayoutGroupBy',
} as DefineComponent
</script>
